import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { HormonalStorm } from './components/HormonalStorm';
import { MechanismSection } from './components/MechanismSection';
import { ProductPresentation } from './components/ProductPresentation';
import { BonusStack } from './components/BonusStack';
import { ValueStack } from './components/ValueStack';
import { Testimonials } from './components/Testimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { TwoPathsSection } from './components/TwoPathsSection';
import { FinalCTA } from './components/FinalCTA';
import { PostScripts } from './components/PostScripts';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen w-full bg-warmWhite font-sans text-dark overflow-x-hidden" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <HormonalStorm data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <BonusStack data-id="element-8" />
        <ValueStack data-id="element-9" />
        <Testimonials data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <TwoPathsSection data-id="element-13" />
        <FinalCTA data-id="element-14" />
        <PostScripts data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}